import { useNavigate } from "react-router";
import React, { useEffect, useRef, useState } from "react";
import { useStore } from "../store/store";
import { API_URL } from "../api/client";
import { takeReturnTo } from "../layout/RequireAuth";
import { Else, If, Then } from "react-if";
import { useSearchParams } from "react-router-dom";
export const LoginPage = () => {
  const navigate = useNavigate();
  const store = useStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");
  const status = searchParams.get("success") === "true";
  const message = decodeURIComponent(searchParams.get("message") as string);
  const ran = useRef(false);
  // Neither a result of the login nor an error: the user was sent here to log in.
  const needsLogin = !token && !status && !searchParams.has("error") && !searchParams.has("message");
  // The bot's team put the account on the blacklist: the API refused to start a session.
  const blocked = searchParams.get("error") === "blocked";

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (token) {
      store.setToken(token!);
      store.restoreSession();
    }
  }, [token]);

  return (
    <div>
        <section className="overflow-y-auto select-none flex flex-col text-white">
          <div
            className={
              "flex flex-col items-center justify-center h-screen text-xl text-white font-sans"
            }
          >
            {needsLogin ? (
              <>
                <div className={"text-2xl xl:text-4xl font-bold"}>
                  Zaloguj się
                </div>
                <div className={"text-lg xl:text-md font-bold"}>
                  Panel jest dostępny po zalogowaniu przez Discord
                </div>
                <a
                  href={`${API_URL}/auth`}
                  className="flex items-center mt-10 justify-center text-white px-4 py-2 text-1xl font-bold border border-white rounded-full hover:text-white"
                >
                  Zaloguj przez Discord
                </a>
              </>
            ) : (
            <If condition={status}>
              <Then>
                <div
                  className={"text-green-500 text-2xl xl:text-4xl font-bold"}
                >
                  Sukces
                </div>
                <div className={"text-lg xl:text-md font-bold"}>
                  Zostałeś pomyślnie zalogowany/a
                </div>
                <button
                  className="flex items-center mt-10 justify-center text-white px-4 py-2 text-1xl font-bold border border-white rounded-full hover:text-white"
                  onClick={() => {
                    // Back to the page the user was sent away from, if any.
                    navigate(takeReturnTo() ?? "/dashboard");
                  }}
                >
                  Przejdź do profilu
                </button>
              </Then>
              <Else>
                {blocked ? (
                  <>
                    <div className={"text-red-500 text-2xl font-bold"}>Dostęp zablokowany</div>
                    <div className={"text-lg font-bold"}>Twój dostęp do MysterBota został zablokowany.</div>
                    <button
                      className="flex items-center mt-10 justify-center text-white px-4 py-2 text-1xl font-bold border border-white rounded-full hover:text-white"
                      onClick={() => {
                        navigate({ pathname: "/" });
                      }}
                    >
                      Wróć na stronę główną
                    </button>
                  </>
                ) : (
                <Then>
                  <div className={"text-red-500 text-2xl font-bold"}>
                    Błąd logowania
                  </div>
                  <div className={"text-lg font-bold"}>
                    Zbieramy informację o twoim problemie
                  </div>
                  <div className={"text-gray-500 text-sm font-bold"}>
                    Odpowiedź z serwera: {message}
                  </div>
                  <button
                    className="flex items-center mt-10 justify-center text-white px-4 py-2 text-1xl font-bold border border-white rounded-full hover:text-white"
                    onClick={() => {
                      navigate({ pathname: "/" });
                    }}
                  >
                    Wróć na stronę główną
                  </button>
                </Then>
                )}
              </Else>
            </If>
            )}
          </div>
        </section>
      </div>
  );
};
